import { Flex, Text } from "@radix-ui/themes";

export default function EmptyPlayer() {
  return (
    <Flex className="fixed left-0 right-0 bottom-0 z-[60]">
      <Flex className="w-full">
        <Flex className="pointer-events-auto flex h-[72px] w-full items-center gap-6 bg-[#050506] px-6 text-white shadow-[0_-4px_12px_rgba(0,0,0,0.25)] backdrop-blur-sm">
          <Flex className="items-center gap-3">
            <Flex className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/60">
              <Text className="text-[15px] font-semibold">--</Text>
            </Flex>
            <Flex direction="column" className="gap-1">
              <Text className="text-sm font-bold text-white/80">
                Nothing playing
              </Text>
              <Text className="text-xs font-semibold text-white/50">
                Select a track to start listening
              </Text>
            </Flex>
          </Flex>
          <Flex className="flex-1 items-center justify-center"></Flex>
          <Flex className="flex items-center gap-2.5 text-white/40">
            <Flex className="h-10 w-10 rounded-full bg-white/6" />
            <Flex className="h-10 w-10 rounded-full bg-white/6" />
            <Flex className="h-10 w-10 rounded-full bg-white/6" />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
